import { Link } from 'react-router-dom'
import './AboutContent.css'
import React from 'react'
import p2 from '../assets/estate4.png'
import p3 from '../assets/gym2.png'

const AboutContent = () => {
    return (
        <div className='about'>
            <div className='left'>
                <h1>Who Am I ?</h1>
                <p>I am a full stack developer. i create responsive secure websites for my clients.</p>
                <Link to='/contact'>
                    <button className='btn'>Contact</button>
                </Link>
            </div>
            <div className='right'>
                <div className='img-container'>
                    <div className='img-stack top'>
                        <img src={p2} alt='true' />
                    </div>
                    <div className='img-stack bottom'>
                        <img src={p3} alt='true' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutContent